import { defineComponent, ref, computed, nextTick, getCurrentInstance } from "vue";
import { definePropType } from "@types-vue/props";
import { getMessageTitle, getMessageContent } from "./index";
export default defineComponent({
    props: {
        showTitle: {
            type: Boolean,
            default: true
        },
        message_langs: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var imgPreviewSrc = ref([]);
        var previewRef = ref();
        var getMessageLangs = computed(function() {
            var langs = root.$route.query.message_langs;
            return langs ? JSON.parse(langs) : props.message_langs;
        });
        var handleClickImage = function(event) {
            if (event.target.nodeName === "IMG" || event.target.nodeName === "img") {
                imgPreviewSrc.value = [
                    event.target.currentSrc
                ];
                nextTick(function() {
                    var // @ts-ignore
                    _$ref;
                    (_$ref = previewRef.value) === null || _$ref === void 0 ? void 0 : _$ref.clickHandler();
                });
            }
        };
        return {
            previewRef: previewRef,
            imgPreviewSrc: imgPreviewSrc,
            getMessageLangs: getMessageLangs,
            getMessageTitle: getMessageTitle,
            getMessageContent: getMessageContent,
            handleClickImage: handleClickImage
        };
    }
});
